/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

// @ts-expect-error
import {openSetCollectionModal} from 'registry/SetCollectionModal';
import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  disabled?: boolean;
  files: Array<any>;
  // This callback aims to track user clicks.
  onClickTracking?: () => void;
}

class SetCollectionModalButton extends React.Component<Props> {
  private handleOpenSetCollectionModal = (): void => {
    this.props.onClickTracking?.();
    openSetCollectionModal({files: this.props.files});
  };

  render(): JSX.Element {
    return (
      <Tooltip container="body" placement={TooltipPlacement.TOP} title="Change collection...">
        <Button
          buttonStyle={ButtonStyle.TERTIARY_WHITE}
          disabled={this.props.disabled}
          icon="add-collection"
          onClick={this.handleOpenSetCollectionModal}
          size={ButtonSize.SMALL}
        />
      </Tooltip>
    );
  }
}

export default SetCollectionModalButton;
